"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userEntitiesSelector = exports.getUserById = exports.getPresenceByUserId = void 0;
var _reselect = require("reselect");
var _selectors = require("../entities/selectors");
var _selectors2 = require("../session/selectors");
var _constants = require("./constants");
var userEntitiesSelector = state => (0, _selectors.entitiesSelector)(state).users;
exports.userEntitiesSelector = userEntitiesSelector;
var userEntities = (state, _user) => userEntitiesSelector(state)[_user];
var getPresenceByUserId = exports.getPresenceByUserId = (0, _reselect.createSelector)([userEntities, _selectors2.myPresenceSelector, _selectors2.getUserId], (user, myPresence, _me) => {
  var _user$status;
  if (!user) {
    return _constants.PRESENCE_STATUS.DISCONNECTED;
  }
  if (user.id === _me) {
    return myPresence;
  }
  return (_user$status = user.status) !== null && _user$status !== void 0 ? _user$status : _constants.PRESENCE_STATUS.DISCONNECTED;
});
var getUserById = exports.getUserById = (0, _reselect.createSelector)(userEntities, user => user);